import React from 'react'
import './PopupPointer.scss'

const PopupPointer = props => {
    return (       
        <div className={`PopupPointer ${props.class}`}>   
            <div className="text-content">
                <div dangerouslySetInnerHTML={{__html: props.text}}></div>
                <div  id={`close-button`} className="global-button" onClick={props.onClose}>Close</div>
            </div>
        </div>
    )
}

export default PopupPointer